var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgEmail = function (props) { return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: [_jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M2.063 6.12 9 10.125l6.938-4.005" }), _jsx("path", { stroke: "currentColor", strokeLinejoin: "round", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M2.063 3.563h13.875v10.875H2.063z" })] }))); };
export default SvgEmail;
